import { render, staticRenderFns } from "./ManageProgramFeatures.vue?vue&type=template&id=6b5b3c8a&scoped=true&"
import script from "./ManageProgramFeatures.vue?vue&type=script&lang=js&"
export * from "./ManageProgramFeatures.vue?vue&type=script&lang=js&"
import style0 from "./ManageProgramFeatures.vue?vue&type=style&index=0&id=6b5b3c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5b3c8a",
  null
  
)

export default component.exports